// extracted by mini-css-extract-plugin
module.exports = {"list":"NavigationItems_list__g9Zve"};